import api from "../../system/api";
import {getStorage} from "../../system/storage";

// Global search (backend: src/search in zofino-strapi; docs/tasks/21-global-search.md).
// params: {q, type, page, pageSize, status, person, from, to}; `signal` cancels a request a newer one replaced.
export const searchApi = {
    search: async (params, {signal} = {}) => {
        const query = Object.fromEntries(Object.entries(params || {}).filter(([, value]) => value !== null && value !== undefined && value !== ""));
        const response = await api.get("/search", {
            params: query,
            headers: {workspace: getStorage("workspace")},
            signal,
            suppressGlobalErrorHandler: true,
        });
        return response?.data?.data || {total: 0, groups: []};
    },
};
